import { CustomSection } from 'styles/GlobalStyle'
import { VersionStyles } from './Style'
import { Record } from 'components'
import { Page } from 'pages'
import VersionCard from './VersionCard'
import Comparison from './Comparison'

const Versions = (props) => {
    const { assessmentVersion1, assessmentVersion2, version1, version2, setVersion1, setVersion2, versions, wrongWords2, wrongWords1 } = props

    return (
        <Page>
            <CustomSection height={200} $bg align="center">
                <Record actionBtns={[]} id="StopMarkingWords" changeSetting showTimeline />
            </CustomSection>
            <VersionStyles>
                <div className='wrap-assessment-versions'>
                    <div className='assessment-versions'>
                        <VersionCard versions={versions} assessmentVersion={assessmentVersion1} version={version1} setVersion={setVersion1} />
                        <VersionCard versions={versions} assessmentVersion={assessmentVersion2} version={version2} setVersion={setVersion2} />
                    </div>
                </div>
                <Comparison assessmentVersion1={assessmentVersion1} assessmentVersion2={assessmentVersion2} wrongWords2={wrongWords2} wrongWords1={wrongWords1} />
            </VersionStyles>
        </Page>
    )

}

export default Versions